import { Stack, Typography } from "@mui/material"
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { formatDate } from 'utils/formatDate';

const ActivityLogMessage = ({fullName, action, metadata}) => {
    switch (action) {
      case "LOGIN":
        return (
          <Typography fontSize={14}>
            <b>{fullName}</b> logged in from IP Address <b>{metadata?.client_ip}</b> using <b>{metadata?.client_os}</b>
          </Typography>
        )
      case "UPDATE_PASSWORD":
        return (
          <Typography fontSize={14}>
            <b>{fullName}</b> changed password
          </Typography>
        )
      case "UPDATE_USER":
      case "UPDATE_PROFILE":
        return (
          <Typography fontSize={14}>
            <b>{fullName}</b> changed {Object.keys(metadata)[0].replace(/_/g, ' ')} to <b>{metadata?.[Object.keys(metadata)[0]]}</b>
          </Typography>
        )
      default: 
        return (
          <Typography fontSize={14}></Typography>
        )
    }
  }

  export const ActivityLogCard = ({log}) => {
    return (
      <Stack direction='row' spacing={2} className='py-4'>
        {log?.avatar_path ? (
          <img 
            alt="account-profile-image"
            src={log.avatar_path} 
            className='w-16 h-16 rounded-full shrink-0 object-cover'
          />
        ) : (
          <AccountCircleRoundedIcon
            viewBox="2 2 20 20"
            aria-label='account-profile-image-default'
            className="p-0"
            sx={{ height: "64px", width: "64px", color: "#ccc" }}
          />)
        }
        <Stack spacing={1} justifyContent="center">
          <ActivityLogMessage action={log.action} metadata={log.metadata} fullName={log.full_name}/>
          <Typography fontSize={12} color='#5F737F'>
            {formatDate.toFullDateTimeWithMonthName(log.log_time)}
          </Typography>
        </Stack>
      </Stack>
    )
  }
  